import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetEnterpriseDashboardExportReportInterface {
  startDate: string;
  endDate: string;
  eid: string;
}

export const useGetEnterpriseDashboardDownloadView = () => {
  const mutate = useMutation(
    ({ startDate, endDate, eid }: GetEnterpriseDashboardExportReportInterface) => {
      return get(
        `/external-api/export_enterprise_excel_with_date_range/${eid}/${startDate}/${endDate}`,
        {
          responseType: 'blob',
        },
      );
    },
  );

  return mutate;
};

export default useGetEnterpriseDashboardDownloadView;
